export const AccessHardware = {
  CONTRACTOR_LOCKBOX: 'contractor_lockbox',
  KEYPAD: 'keypad',
  CODEBOX: 'codebox',
  SENTRILOCK: 'sentrilock',
  IGLOO: 'igloo',
  OTHER: null,
};

export const providers = {
  CODEBOX: {
    value: AccessHardware.CODEBOX,
    label: 'Codebox',
  },
  SENTRILOCK: {
    value: AccessHardware.SENTRILOCK,
    label: 'Sentrilock',
  },
  IGLOO: {
    value: AccessHardware.IGLOO,
    label: 'Igloo',
  },
};
